<template>
  <div class='SDAU_style'>
    <div style="padding: 32px 0 32px 0;">
      <span style="font-size:14px;color:#999999;">
        您的位置：
        <span style='color:#999999;cursor: pointer;' @click="toHome">首页></span>
        <span style="color:#999999;cursor: pointer;" @click="toEqment">仪器设备></span>
        <span style="color:#188335">更多信息</span>
      </span>
    </div>
    <div class='card_box'>
      <div class='top_box'>
        <el-image style='width: 584px;height: 360px;vertical-align:top' v-if='formData.extData'
          :src="baseurl + '/' + formData.extData.thumbnailPath" :preview-src-list="showurlList">
        </el-image>
        <img v-else style='width: 584px;height: 360px; vertical-align:top' src="../../../assets/images/img_blank.png">
        <div class='right_box'>
          <div class='boxtitle'>
            {{ formData.equipmentName }}
          </div>
          <el-row style='margin-top:16px'>
            <el-col style='margin-top:16px' :span='12'>
              <span style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #666666;'>设备编码：</span>
              <span
                style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #333333;margin-left:16px'>{{
                  formData.equipmentNumber }}</span>
            </el-col>
            <el-col style='margin-top:16px' :span='12'>
              <span style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #666666;'>设备状态：</span>
              <span v-if='formData.status'
                style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #333333;margin-left:16px'>{{
                  statusList[Number(formData.status) - 1].label }}</span>
            </el-col>
            <el-col style='margin-top:16px' :span='12'>
              <span style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #666666;'>规格型号：</span>
              <span
                style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #333333;margin-left:16px'>{{
                  formData.equipmentModel }}</span>
            </el-col>
            <el-col style='margin-top:16px' :span='12'>
              <span style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #666666;'>设备分类：</span>
              <span
                style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #333333;margin-left:16px'>{{
                  formData.nodeName }}</span>
            </el-col>
            <el-col style='margin-top:16px' :span='12'>
              <span style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #666666;'>设备品牌：</span>
              <span
                style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #333333;margin-left:16px'>{{
                  formData.equipmentBrand }}</span>
            </el-col>
            <el-col style='margin-top:16px' :span='12'>
              <span style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #666666;'>生产厂商：</span>
              <span
                style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #333333;margin-left:16px'>{{
                  formData.manufacturer }}</span>
            </el-col>
            <el-col style='margin-top:16px' :span='12'>
              <span style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #666666;'>出厂编号：</span>
              <span
                style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #333333;margin-left:16px'>{{
                  formData.factoryNumber }}</span>
            </el-col>
            <el-col style='margin-top:16px' :span='12'>
              <span style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #666666;'>出厂日期：</span>
              <span
                style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #333333;margin-left:16px'>{{
                  formData.productionDate }}</span>
            </el-col>
            <el-col style='margin-top:16px' :span='12'>
              <span style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #666666;'>设备单价：</span>
              <span
                style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #333333;margin-left:16px'>{{
                  formData.purchasePrice }}</span>
            </el-col>
            <el-col style='margin-top:16px' :span='12'>
              <span style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #666666;'>到货日期：</span>
              <span
                style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #333333;margin-left:16px'>{{
                  formData.arrivalDate }}</span>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class='bottom_box'>
        <el-tabs v-model="activeName" :before-leave="handleClick">
          <el-tab-pane label="基本信息" name="first">
            <div
              style='font-family: Source Han Sans SC;font-weight: 500;font-size: 16px;color: #333333;margin-top:32px;margin-bottom:32px'>
              管理员信息
            </div>
            <el-row style='width: 60%;'>
              <el-col style='margin-top:16px' :span='12'>
                <span
                  style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #666666;margin-left:16px'>设备管理员：</span>
                <span
                  style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #333333;margin-left:16px'>{{
                    formData.mainUserName + ' ' + formData.mainUserPhone }}</span>
              </el-col>
              <el-col style='margin-top:16px' :span='12'>
                <span
                  style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #666666;margin-left:50px'>辅助管理员：</span>
                <span v-if="formData.assistUserName"
                  style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #333333;margin-left:16px'>{{
                    formData.assistUserName + ' ' + formData.assistUserName }}</span>
              </el-col>
            </el-row>

            <div
              style='font-family: Source Han Sans SC;font-weight: 500;font-size: 16px;color: #333333;margin-top:32px;margin-bottom:32px'>
              位置信息
            </div>
            <el-row style='width: 60%;'>
              <el-col style='margin-top:16px' :span='12'>
                <span
                  style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #666666;margin-left:16px'>所在区域：</span>
                <span
                  style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #333333;margin-left:16px'>{{
                    formData.location }}</span>
              </el-col>
              <el-col style='margin-top:16px' :span='12'>
                <span
                  style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #666666;margin-left:50px'>所在实验室：</span>
                <span
                  style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #333333;margin-left:16px'>{{
                    formData.equipmentAreaName }}</span>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="预约情况" name="second">
            <div class='dateBox'>
              <el-date-picker v-model="dateRange" @change="getSelectValue" type="daterange" value-format="yyyy-MM-dd"
                range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <el-table :data="tableData" border :cell-style="setColor" :max-height="500">
              <el-table-column label="当天时间" align="right" width="150" fixed="left">
                <el-table-column prop="rowName" label="周天" width="150" fixed="left">
                </el-table-column>
              </el-table-column>
              <el-table-column v-for='(item, index) in duringHeader' :key='index' :prop="item" width="120" :label="item"
                align="center">
                <template slot-scope="scope">
                  <p v-if="scope.row[item]">{{ scope.row[item].split('$$')[0] }}</p>
                  <p v-if="scope.row[item]">{{ scope.row[item].split('$$')[1] }}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="查看附件" name="third">
            <el-table :data="formData.fileList" style='width: 60%;'>
              <el-table-column type="index" width="55" label="序号" align="center">
              </el-table-column>
              <el-table-column prop="fileTypeName" width="150" label="附件类型" align="center">
              </el-table-column>
              <el-table-column prop="fileName" label="附件名称" align="center">
              </el-table-column>
              <el-table-column label="操作" width="180" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button v-if="['pdf', 'jpg', 'png'].includes(scope.row.filePath.split('.')[1])" type="text"
                    size="small" v-Login="() => downLoadorshow(scope.row.filePath, scope.row.fileName, 0)">查看</el-button>
                  <el-button type="text" size="small"
                    v-Login="() => downLoadorshow(scope.row.filePath, scope.row.fileName, 1)">下载</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog :title="'预览'" :visible.sync="showFormDetail" append-to-body center top="10px" :show-close="true"
      @close="showFormDetail = false" :close-on-press-escape="false" class="QMS-dialog QMS-dialog_center"
      :close-on-click-modal="false">
      <iframe style="width: 100%; height: 75vh" :src="pdfURL" frameborder="0" v-if="showFormDetail"></iframe>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showFormDetail = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
const { APIURl } = require('@/utils/apiUrl')
import { downloadFileofurl } from '@/api/downLoad/downLoad.js'
export default {
  data() {
    return {
      formData: {
      },
      showFormDetail: false,
      imageData: {
        url: []
      },
      eqId: '',
      baseurl: '',
      showurlList: [],
      activeName: 'first',
      statusList: [
        { ststus: '1', label: '正常' },
        { ststus: '2', label: '停用' },
        { ststus: '3', label: '维修中' },
        { ststus: '4', label: '维护保养中' },
        { ststus: '5', label: '报废' },
      ],
      dateRange: [],
      selectList: [],
      ifcanAllline: true,
      startDate: '',
      endDate: '',
      duringHeader: [
      ],
      tableData: [
      ],
      minTime: '',
      maxTime: '',
      pdfURL: ''
    }
  },
  methods: {
    init() {
      this.dateRange[0] = this.getNowFormatDate(0, 1)
      this.dateRange[1] = this.getNowFormatDate(6, 1)
      this.baseurl = APIURl
      this.eqId = this.$route.query.id
      this.$net(`/v1/userClient/home/selectEquipmentDetail/${this.eqId}`, 'get').then(res => {
        this.formData = res.data
        this.showurlList[0] = this.formData.extData.thumbnailPath ? APIURl + '/' + this.formData.extData.thumbnailPath : ''
      })
    },

    downLoadorshow(url, name, downtype) {
      if (downtype) {
        downloadFileofurl('/' + url, name)
      }
      else {
        if (url.split('.')[1] == 'pdf') {
          this.pdfURL = "/pdfjs/web/viewer.html?file=" + APIURl + '/' + url;
          this.showFormDetail = true
        }
        else {
          this.imageData.url = [APIURl + '/' + url]
          this.$viewerApi({
            images: this.imageData.url
          })
        }
      }
    },
    getNowFormatDate(n, dateStatus, needSeconds, needDate) {
      if (needDate) {
        let date = new Date(needDate).getTime()
        return date
      }
      else {
        let date = new Date(),
          year = date.getFullYear(),
          month = date.getMonth() + 1,
          strDate = date.getDate() + n
        let hour = date.getHours()
        let minutes = date.getMinutes()
        let Seconds = date.getSeconds()
        if (month < 10) month = `0${month}`
        if (strDate < 10) strDate = `0${strDate}`
        if (hour < 10) hour = `0${hour}`
        if (minutes < 10) minutes = `0${minutes}`
        if (Seconds < 10) Seconds = `0${Seconds}`
        let str = needSeconds ? `${year}-${month}-${strDate} ${hour}:${minutes}:${Seconds}` : `${year}-${month}-${strDate}`
        let dates = dateStatus ? str : new Date(str).getTime()
        return dates
      }

    },
    handleClick(activeName, oldActiveName) {
      if (activeName != 'second') {
        return
      }
      this.startDate = this.getNowFormatDate(0, 1)
      this.endDate = this.getNowFormatDate(6, 1)
      this.$net(`/sdau/deviceReservation/reservedList`, 'get', { equipmentId: this.eqId, startDate: this.startDate, endDate: this.endDate }).then(res => {
        this.duringHeader = res.data.titleList
        this.tableData = res.data.reservedDeviceList
        this.minTime = res.data.minInterval
        this.maxTime = res.data.maxAppointmentTime
        this.detailTableData()
      })
    },
    detailTableData() {
      this.tableData.forEach(item => {
        item.reservedList.forEach(item2 => {
          this.$set(item, item2.timeStr, item2.reservationUserName + '$$' + item2.reservationUserPhoneNubmer)
        })
      })
    },
    getSelectValue() {
      if (this.dateRange) {
        this.startDate = this.dateRange[0]
        this.endDate = this.dateRange[1]
      }
      else {
        this.startDate = ''
        this.endDate = ''
      }
      this.$net(`/sdau/deviceReservation/reservedList`, 'get', { equipmentId: this.eqId, startDate: this.startDate, endDate: this.endDate }).then(res => {
        this.duringHeader = res.data.titleList
        this.tableData = res.data.reservedDeviceList
        this.minTime = res.data.minInterval
        this.maxTime = res.data.maxAppointmentTime
        this.detailTableData()
      }).catch(error => {
        this.tableData = []
      })
    },
    setColor({ row, column, rowIndex, columnIndex }) {
      if (columnIndex != 0) {
        let ifSelect = false
        this.selectList.length ? ifSelect = !(this.getNowFormatDate(0, 0, 0, row.date + ' ' + column.label.split('~')[0]) < this.getNowFormatDate(0, 0, 0, this.selectList[0].date + ' ' + this.selectList[0].time.split('~')[0]) || this.getNowFormatDate(0, 0, 0, row.date + ' ' + column.label.split('~')[0]) > this.getNowFormatDate(0, 0, 0, this.selectList[this.selectList.length - 1].date + ' ' + this.selectList[this.selectList.length - 1].time.split('~')[0])) : null
        if (row.reservedList.map(item => { return item.timeStr }).includes(column.property)) {
          ifSelect ? (this.$message({ type: 'warning', message: '选择时间包含已预约时间，请重新选择' }), this.selectList = []) : null
          return `background:rgb(219, 94, 94);cursor: default`
        }
        else {
          if (this.getNowFormatDate(0, 0, 1) >= this.getNowFormatDate(0, 0, 0, row.date + ' ' + column.label.split('~')[0])) {
            ifSelect ? (this.$message({ type: 'warning', message: '当前时间之前不可选择' }), this.selectList = []) : null
            return `background:rgb(138 138 138 / 62%);cursor: default`
          }
          else {
            if (row.schedulingRuleLimitList.includes(column.property)) {
              ifSelect ? (this.$message({ type: 'warning', message: '选择时间包含设备不可预约时间，请重新选择' }), this.selectList = []) : null
              return `background:rgb(138 138 138 / 62%);cursor: default`
            }
          }
        }
        if (ifSelect) {
          return `background:rgb(76, 110, 184);cursor: pointer`
        }
        return `cursor: pointer`
      }
    },


    toHome() {
      this.$router.push({ path: '/' })
    },
    toEqment() {
      this.$router.push({ path: '/EqMent' })
    },
  },
  created() {
    this.init()
  },
}
</script>
<style lang="scss" scoped>
.SDAU_style {
  padding-bottom: 32px;
}

.card_header {
  padding: 19px 0 19px 32px;
  font-size: 18px;
  font-family: Source Han Sans SC;
  font-weight: bold;
  color: #333333;
  border: 1px solid #d7dce0;
  border-bottom: none;
  background: #f6f6f6;
}

.card_box {
  width: 100%;

  .top_box {
    height: 424px;
    background-color: #fff;
    padding: 32px 16px 32px 32px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;

    .right_box {
      width: calc(100% - 620px);

      .boxtitle {
        padding: 16px 0 32px 0;
        border-bottom: 1px solid #d7dce0;
        font-weight: 500;
        font-size: 24px;
        color: #333333;
        font-family: Source Han Sans SC;
      }
    }
  }

  ::v-deep .bottom_box {
    background-color: #fff;
    padding: 32px 16px 32px 32px;

    .el-tabs__item {
      font-size: 16px;
    }
  }
}

::v-deep.dateBox {
  display: flex;
  margin-bottom: 20px;
  justify-content: center;

  .el-date-editor {
    width: 30%;
  }
}

::v-deep.selectBox {
  .el-dialog__header {
    border-bottom: 1px #d7dce0 solid;
    padding: 0 0;
    height: 56px;
    line-height: 56px;
    font-weight: 800;
    color: black;
    // color: rgb(76, 110, 184);

    .el-dialog__headerbtn {
      top: 16px;
      right: 16px;

      .el-dialog__close {
        font-size: 24px;
      }
    }
  }

  .el-table tr td {
    height: 60px;
  }
}

.timebox {
  ::v-deep .el-table th {
    overflow: initial;
  }

  ::v-deep.el-table th>.cell {
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 14px;
    color: #2e3444;
  }

  ::v-deep.el-table thead tr:first-of-type th:first-of-type,
  .el-table thead tr:nth-of-type(2) th:first-of-type {
    border-bottom: none;
    padding: 0;
  }

  ::v-deep.el-table thead tr:last-of-type th:first-of-type:before {
    content: '';
    position: absolute;
    width: 1px;
    background-color: #ebeef5;
    display: block;
  }

  ::v-deep.el-table thead tr:last-of-type th:first-of-type:before {
    height: 183px; //根据情况调整
    bottom: 0;
    right: 0; //根据情况调整
    transform: rotate(-72deg); //根据情况调整
    transform-origin: bottom;
  }

  ::v-deep.el-table tbody tr td:first-of-type .cell {
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 14px;
    color: #2e3444;
    font-weight: 600;
    text-align: center;
  }
}
</style>
